export default [
  {
    key: 'startDate',
    label: 'field.fromDate',
    type: 'date',
    lg: 12,
  },
  {
    key: 'endDate',
    label: 'field.toDate',
    type: 'date',
    lg: 12,
  },
];
